// extracted by mini-css-extract-plugin
export default {"title":"templateStyles_title__NsUPt","template":"templateStyles_template__eyFoF","custom_message":"templateStyles_custom_message__vBvc3"};